import { createReducer, on } from '@ngrx/store';

import { ListActions } from './list.actions';
import { ListState } from './list.models';

export const initialListState: ListState = {
    listGuids: [],
    listNewGuids: [],
    selectedNodeUuid: '',
    nodesExpandState: {},
    isLoading: false,
};

export const listReducer = createReducer(
    initialListState,
    on(ListActions.setListGuids, (state, action): ListState => {
        return {
            ...state,
            listGuids: Array.from(action.listGuids),
            isLoading: false,
        };
    }),
    on(ListActions.navigateObject, (state, { nodeUuid }): ListState => {
        return { ...state, selectedNodeUuid: nodeUuid };
    }),
    on(ListActions.changeNodeExpandedState, (state, { nodeUuid, isExpanded }): ListState => {
        return {
            ...state,
            nodesExpandState: {
                ...state.nodesExpandState,
                [nodeUuid]: isExpanded,
            },
        };
    }),
    on(ListActions.changeAllNodesExpandedState, (state, { expanderNodes, isExpanded }): ListState => {
        const newExpandState = expanderNodes.reduce((acc, node) => {
            acc[node.id] = isExpanded;
            return acc;
        }, {});
        return {
            ...state,
            nodesExpandState: newExpandState,
        };
    }),
    on(ListActions.resetNodeExpandedState, (state): ListState => {
        return {
            ...state,
            nodesExpandState: {},
        };
    }),
    on(ListActions.addListGuids, (state, { listGuids }): ListState => {
        const newListGuids = new Set([...state.listGuids, ...listGuids]);
        return {
            ...state,
            listGuids: Array.from(newListGuids),
        };
    }),
    on(ListActions.addNewListGuids, (state, { listGuids }): ListState => {
        const newListGuids = new Set([...state.listNewGuids, ...listGuids]);
        return {
            ...state,
            listNewGuids: Array.from(newListGuids),
        };
    }),
    on(ListActions.removeListGuids, (state, { listGuids }): ListState => {
        const newListGuids = new Set(state.listGuids);
        listGuids.forEach(guid => newListGuids.delete(guid));
        return {
            ...state,
            listGuids: Array.from(newListGuids),
        };
    }),
    on(ListActions.clearNewListGuids, (state): ListState => {
        return {
            ...state,
            listNewGuids: [],
        };
    }),
    on(ListActions.setLoading, (state, { isLoading }): ListState => {
        return {
            ...state,
            isLoading,
        };
    })
);
